import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { setActiveTabKey } from '../../../../../redux/slices/LocationManagementSidePanelSlice';
import TabsContainer from '../../../../../shared-components/tabs-container/TabsContainer';
import Devices from '../../location-dashboard/Devices';

import Alerts from './Alerts';
import CommercialSessionTable from './CommercialSessionTable';
import GuestCharging from './GuestCharging';
import LocationActivity from './LocationActivity';
import LocationDetails from './LocationDetails';
import Transactions from './Transactions';
import UpcomingMaintenanceSchedule from './UpcomingMaintenanceSchedule';
import Uptime from './Uptime';

interface LocationDetailsTabProperties {
  label: string;
  key: string;
  isActive: boolean;
  count?: number;
}

/**
 * Station management bottom container component
 * @returns {any} The rendered component
 */
function LocationManagementBottomContainer() {
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation('sidePanel');
  const { activeTabKey } = useAppSelector(
    (state) => state.locationManagement,
  );

  const { totalResults: alertsCount } = useAppSelector((state) => state.alertsLocation);
  const { totalResults: sessionsCount } = useAppSelector((state) => state.locationDetailsChargingSession);

  const stationDetailsTab = useMemo<LocationDetailsTabProperties[]>(
    () => [
      // {
      //   label: t('stationDetails'),
      //   key: 'stationDetails',
      //   isActive: activeTabKey === 'stationDetails',
      // },
      {
        label: t('liveLogsSession'),
        key: 'liveLogsSession',
        isActive: activeTabKey === 'liveLogsSession',
        count: sessionsCount || 0,
      },
      {
        label: t('stationActivity'),
        key: 'stationActivity',
        isActive: activeTabKey === 'stationActivity',
      },
      {
        label: t('chargers'),
        key: 'chargers',
        isActive: activeTabKey === 'chargers',
      },

      // {
      //   label: t('alerts'),
      //   key: 'alerts',
      //   isActive: activeTabKey === 'alerts',
      //   count: alertsCount || 0,
      // },
      {
        label: t('transactions'),
        key: 'transaction',
        isActive: activeTabKey === 'transaction',
      },
      // {
      //   label: t('guestCharging'),
      //   key: 'guestCharging',
      //   isActive: activeTabKey === 'guestCharging',
      // },
      {
        label: t('upcomingMaintenanceSchedule'),
        key: 'upcomingMaintenanceSchedule',
        isActive: activeTabKey === 'upcomingMaintenanceSchedule',
      },
      // {
      //   label: t('upTime'),
      //   key: 'upTime',
      //   isActive: activeTabKey === 'upTime',
      // },
    ],
    [t, activeTabKey, alertsCount, sessionsCount],
  );

  /**
   * Function to switch the tab
   * @param {string} key The key of the tab to switch to
   */
  const handleSwitchTab = (key: string) => {
    dispatch(setActiveTabKey(key));
  };

  return (
    <div className="location-management-bottom-wrap" dir={i18n.dir()}>
      <TabsContainer
        containerTabs={stationDetailsTab}
        handleSwitchTab={handleSwitchTab}
        className="location-management-bottom-tab"
      />
      <div className="location-management-bottom-container">
        {(() => {
          switch (activeTabKey) {
            case 'stationDetails':
              return <LocationDetails />;
            case 'stationActivity':
              return <LocationActivity />;
            case 'liveLogsSession':
              return <CommercialSessionTable />;
            case 'alerts':
              return <Alerts />;
            case 'transaction':
              return <Transactions />;
            case 'guestCharging':
              return <GuestCharging />;
            case 'upcomingMaintenanceSchedule':
              return <UpcomingMaintenanceSchedule />;
            case 'upTime':
              return <Uptime />;
            case 'chargers':
              return <Devices />;
            default:
              return null;
          }
        })()}
      </div>
    </div>
  );
}

export default LocationManagementBottomContainer;
